"use client";

import { motion } from "framer-motion";

const AgentPainBlock = () => {
  return (
    <section className="w-full bg-linear-to-b from-white to-[#F8FAFC] py-24 sm:py-32 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto text-center">
        {/* Headline */}
        <motion.h2
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="judson-regular text-[40px] sm:text-[54px] md:text-[68px] leading-[1.05] text-[#0F172A]"
        >
          Great agents lose deals to confusion
          <br />
          <span className="text-[#94A3B8]">not competition.</span>
        </motion.h2>

        {/* Soft divider */}
        <div className="my-16 flex justify-center">
          <div className="h-px w-100 bg-linear-to-r from-transparent via-[#CBD5E1] to-transparent" />
        </div>

        {/* Body copy */}
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="inter-regular text-lg leading-relaxed text-[#334155] max-w-3xl mx-auto"
        >
          Clients are overwhelmed. Timelines are fragmented. Communication gets
          messy. Even the best agents end up managing chaos instead of building
          relationships.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true }}
          className="inter-regular text-lg leading-relaxed text-[#334155] max-w-3xl mx-auto mt-8"
        >
          When clients feel confused, trust erodes and deals stall.
          <br />
          <br />
          <span className="inter-semibold text-[#0F172A]">
            AskLocal removes friction so you can focus on what matters most.
          </span>
        </motion.p>
      </div>
    </section>
  );
};

export default AgentPainBlock;
